<template>
  <v-layout 
    justify-space-around 
    row 
    wrap 
    scrollDesign 
    style="padding: 5px"
  >
    <!-- TITULO -->
    <v-flex
      xs10
      sm5
      md5
    >
      <v-form
        lazy-validation
        @submit.prevent="next"
      >
        <h1
          class="font-weight-regular"
          v-if="showTitleLabel"
        >
          <b>{{ notice.title }}</b> 
          <v-icon
            style="margin-bottom:5px;"
            color="black"
            @click="editTitle = true; showTitleLabel=false "
            v-if="showTitleLabel"
            icon
          >
            mode_edit
          </v-icon>
        </h1>
        <v-text-field
          label="Título"
          v-model="notice.title"
          outline
          :error-messages="titleErrors"
          style=" margin-top: 25px;"
          v-if="editTitle"
        />
      </v-form>
    </v-flex>
    <v-flex
      sm1
      md1
      right
    >
      <!-- <v-icon color="black"  @click="editTitle = true; showTitleLabel=false " v-if="showTitleLabel" icon>mode_edit</v-icon> -->
      <v-icon
        color="primary"
        @click="editTitle = false; showTitleLabel=true "
        icon
        v-if="editTitle"
      >
        save
      </v-icon>
    </v-flex>
    <v-flex
      offset-sm3
      offset-md3
    />
    <!-- BOTON PROGRAMAR -->
    <v-flex
      sm3
      md3
      right
    >
      <v-checkbox
        v-model="notice.sentToSchedule"
        label="Programar"
        class="black-label"
        style="color: red !important"
      />
    </v-flex>

    <!-- DESCRIPCION -->
    <v-flex
      xs12
      sm6
      md6
    >
      <v-layout
        v-if="showDescriptionText" 
      >
        <v-flex
          xs12
          md12
          sm12
        >
          <div
            style="height: 100%"
          >
            <div
              style="display: inline-block; max-width: 85%; height: 100%"
              v-html="getDescription"
            />
            <div
              style="display: inline-block; min-width: 15%; height: 100%"
            >
              <v-icon
                color="black"
                class="ml-3"
                style="height: 100%"
                @click="editDescription = true; showDescriptionText=false"
                v-if="showDescriptionText"
              >
                mode_edit
              </v-icon>
            </div>
          </div>
        </v-flex>
      </v-layout>
      <v-layout
        v-if="editDescription"
      >
        <v-flex
          xs11
          md11
          sm11
        >
          <v-form
            lazy-validation
            @submit.prevent="next"
          >
            <v-textarea
              id="descriptionField"
              outline
              label="Descripción"
              placeholder="Recuerda añadir en este espacio toda la información del comunicado, como objetivo del comunicado, lugar, horario, etc."
              v-model="v.description.$model"
              :error-messages="descriptionErrors"
              rows="10"
            />
          </v-form>
        </v-flex>

        <v-flex
          xs1
          md1
          sm1
        >
          <v-icon
            color="primary"
            @click="editDescription = false; showDescriptionText=true"
            v-if="editDescription"
          >
            save
          </v-icon>
        </v-flex>
      </v-layout>
    </v-flex>
    
    <v-flex
      offset-sm4
      offset-md4
    />
    <!-- END DESCRIPCION -->

    <!-- FECHAS DEL COMUNICADO -->
    <v-flex
      xs12
      sm8
      md8
      mt-4
    >
      <span
        class="labelTip2"
        v-if="showDatesText && notice.startDate != null && notice.startDate != '' && notice.endDate != null && notice.endDate != ''"
      >Fechas de comunicado:       
      </span>
      <span class="labelTip1">Inicio: {{ notice.startDate | dateFormat2 }} | Final: {{ notice.endDate | dateFormat2 }} <v-icon
        color="black"
        @click="showDatesText = false; showDatesInputs=true "
        v-if="showDatesText"
      >mode_edit</v-icon></span><br>
      <span
        class="labelTip1"
        v-if="notice.type == 'E' && notice.startEventDate != ''"
      >Fecha de inicio de evento: {{ notice.startEventDate | dateFormat2 }}</span>
      <v-form v-show="showDatesInputs">
        <!-- <span class="labelTip" v-if="showDatesInputs">Cambiando fechas de vigencia de comunicado Inicio: {{ notice.startDate | dateFormat2}} | Final: {{ notice.endDate | dateFormat2}}</span> -->
        <!------------------------------  NEW DATE TIME PICKERS  ---------------------------------->
        <v-layout>
          <VueTimePickerTool
            :min="getMinStartDate"
            :refresh="showDatesInputs"
            :error-messages="dateStartErrors"
            title-date="Fecha de inicio de visibilidad del comunicado"
            title-time="Hora de inicio"
            v-model="v.startDate.$model"
            style="margin-top:20px;"
            location="up"
          />
        </v-layout>
        <v-layout>
          <VueTimePickerTool
            :min="getMinEndDate"
            :error-messages="dateEndErrors"
            title-date="Fecha de término de visibilidad del comunicado"
            title-time="Hora de termino"
            v-model="v.endDate.$model"
            location="up"
          />
        </v-layout>
        <v-layout>
          <VueTimePickerTool
            :min="getMinStartEvent"
            :max="getMaxStartEvent"
            :error-messages="dateStartEventErrors"
            title-date="Fecha de incio del evento"
            title-time="Hora de inicio"
            v-model="v.startEventDate.$model"
            location="up"
          />
        </v-layout>
      </v-form>
    </v-flex>
    <v-flex
      xs12
      sm2
      md2
    >
      <!-- <v-icon color="black" @click="showDatesText = false; showDatesInputs=true " v-if="showDatesText">mode_edit</v-icon> -->
      <v-icon
        color="primary"
        @click="showDatesText = true; showDatesInputs=false"
        v-if="showDatesInputs"
      >
        save
      </v-icon>
    </v-flex>
    <v-flex
      offset-xs12
      offset-sm2
      offset-md2
    />

    <!-- IMAGEN V2 -->
    <v-flex
      xs12
      sm6
      md6
    >
      <NoticeImage 
        :type="1"
        v-model="notice.imageStorage" 
      />
    </v-flex>
    <v-flex
      offset-sm6
      offset-md6
    />
      
    <v-flex
      xs12
      sm6
      md6
      class="mt-3"
    >
      <!-- archivos -->
      <v-container class="no-pm">
        <v-container class="no-pm">
          <FileAttachment @selected-file="onSelectedFile" />
          <v-chip
            v-for="(n, key) in notice.files"
            :key="key"
            close
            @input="remove(n, key)"
          >
            <strong>{{ n.name }}</strong>&nbsp;
            <span>{{ (n.size/(1024*1024)).toFixed(2)+"Mb" }}</span>&nbsp;
          </v-chip>
          <!-- <v-flex xs12 class="mt3"></v-flex> -->
        </v-container>
      </v-container>
    </v-flex>  
    <v-flex
      offset-sm3
      offset-md3
    />
    <v-flex 
      xs12 
      sm12 
      md12 
      hidden-xs-only
    >
      <type-statement-selector 
        :type="notice.type"
        :assistanceRequired="notice.assistanceRequired"
        :attendanceStudentRequired="notice.attendanceStudentRequired"
        :confirmParent="notice.confirmParent"
        :showDatePicker="false"
        @type-selected="cambiaTipo"
        @confirm-parent-change="confirmParentChange"
        @assistence-requiered-change="assistenceRequieredChange"
        @attendance-student-required-change="attendanceStudentRequiredChange"
      />
    </v-flex>

    <v-layout
      wrap
      row
    >
      <v-flex
        xs12
        sm4
        md4
      >
        <v-layout
          row
          wrap
          justify-space-around
          scrollDesign
          style="max-height: 320px;"
        >
          <!-- Institucional -->
          <v-flex
            xs12
            v-if="notice.institutional == true"
          >
            <v-alert
              style="border-radius:33px; width: 80%"
              :value="true"
              type="info"
              color="gradiente"
            >
              Toda la institución será notificada
            </v-alert>
          </v-flex>
          <!-- Niveles -->
          <v-flex
            xs12
            v-if="notice.levels.length > 0"
          >
            <v-list
              subheader
              two-line
            >
              <v-subheader key="subheader">
                Niveles
              </v-subheader>
              <v-slide-y-transition
                class="two-line subheader"
                group
              >
                <v-list-tile
                  avatar
                  class="pa-0 mb-3 elevation-1 grey lighten-5 list-group-item item"
                  style="border-radius: 5px; width: 60%"
                  v-for="element in notice.levels"
                  :key="element.id"
                >
                  <v-list-tile-avatar>
                    <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="text-m-center" v-text="element.typeLevel" />
                  </v-list-tile-content>
                </v-list-tile>
              </v-slide-y-transition>
            </v-list>
          </v-flex>
          <!-- grupos -->
          <v-flex
            xs12
            v-if="notice.groups.length > 0"
          >
            <v-list
              subheader
              two-line
            >
              <v-subheader key="subheader">
                Grupos
              </v-subheader>
              <v-slide-y-transition
                class="two-line subheader"
                group
              >
                <v-list-tile
                  avatar
                  class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                  style="border-radius: 5px; width: 60% !important"
                  v-for="element in notice.groups"
                  :key="element.id"
                >
                  <v-list-tile-avatar>
                    <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="text-m-center" v-text="element.grade + ' ' + element.group" />
                    <v-list-tile-sub-title class="text-m-center" v-text="element.level.typeLevel" />
                  </v-list-tile-content>
                </v-list-tile>
              </v-slide-y-transition>
            </v-list>
          </v-flex>
          <!-- subgrupos -->
          <v-flex
            xs12
            v-if="notice.subgroups.length > 0"
          >
            <v-list
              subheader
              two-line
            >
              <v-subheader key="subheader">
                Subgrupos
              </v-subheader>
              <v-slide-y-transition
                class="two-line subheader"
                group
              >
                <v-list-tile
                  avatar
                  class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                  style="border-radius: 5px; width: 60% !important"
                  v-for="element in notice.subgroups"
                  :key="element.id"
                >
                  <v-list-tile-avatar>
                    <v-img :src="require('@/assets/panel/home/SKLB-Niveles.png')" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title class="text-m-center" v-text="element.name + ' '" />
                  <!-- <v-list-tile-title v-text="'Estudiantes: '+element.level.nStudents"></v-list-tile-title> -->
                  <!-- <v-list-tile-sub-title v-text="element.typeLevel"></v-list-tile-sub-title> -->
                  </v-list-tile-content>
                </v-list-tile>
              </v-slide-y-transition>
            </v-list>
          </v-flex>
          <!-- Alumnos -->
          <v-flex
            xs12
            v-if="notice.students.length > 0"
          >
            <v-list
              subheader
              two-line
            >
              <v-subheader key="subheader">
                Alumnos
              </v-subheader>
              <v-slide-y-transition
                class="two-line subheader"
                group
              >
                <v-list-tile
                  avatar
                  class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                  style="border-radius: 5px; width: 70%"
                  v-for="element in notice.students"
                  :key="element.id"
                >
                  <v-list-tile-avatar>
                    <v-img :src="require('@/assets/panel/home/SKLB-Alumnos.png')" />
                  </v-list-tile-avatar>
                  <v-list-tile-content>
                    <v-list-tile-title v-text="element.firstName + ' ' + element.lastName" />
                    <v-list-tile-sub-title
                      v-text="element.level.typeLevel + ' ' + element.gg.grade + ' ' + element.gg.group"
                    />
                  </v-list-tile-content>
                </v-list-tile>
              </v-slide-y-transition>
            </v-list>
          </v-flex>
          <!-- Colaboradores -->
          <v-flex
            xs12
            v-if="notice.employeeAudience.length > 0"
          >
            <v-list
              subheader
              two-line
            >
              <v-subheader key="subheader">
                Colaboradores
              </v-subheader>
              <v-slide-y-transition
                class="two-line subheader"
                group
              >
                <v-list-tile
                  avatar
                  text-center
                  class="pa-0 mb-3 ml-2 elevation-1 grey lighten-5 list-group-item item"
                  style="border-radius: 5px; width: 60% !important"
                  v-for="element in notice.employeeAudience"
                  :key="element.id"
                >
                  <v-list-tile-content>
                    <v-list-tile-title class="text-m-center" v-text="element.name" />
                  </v-list-tile-content>
                </v-list-tile>
              </v-slide-y-transition>
            </v-list>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex
        offset-sm8
        offset-md8
      />
    </v-layout>
  </v-layout>
</template>

<script>
import moment from "moment";
import NoticePDF from "../../Sections/Notices/NoticePDF3";
import FileAttachment from "../../Tools/FileAttachment2";
import VueTimePickerTool from "../Notices/Tools/VueDateTimePicker2";
import NoticeImage from "../../Sections/Notices/NoticesImage3";
import TypeStatementSelector from "../../Tools/TypeStatementSelector";

export default {
  components: {
    NoticePDF,
    FileAttachment,
    VueTimePickerTool,
    NoticeImage,
    TypeStatementSelector
  },
  props: ["notice", "v", "clear"],
  filters: {
    noticeTypeFilter: function(type) {
      switch (type) {
        case "A":
          return "Aviso";
        case "E":
          return "Evento";
        case "P":
          return "Permiso";
        case "R":
          return "Reporte";
      }
    },
    dateFormat(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY");
    },
    dateFormat2(value) {
      return moment(String(new Date(value))).format("DD/MM/YYYY HH:mm");
    }
  },
  watch: {
    clear(){
      if(this.clear){
        this.editTitle = false,
        this.showTitleLabel = true,
        this.editDescription = false,
        this.showDescriptionText = true,
        this.showDatesText = true,
        this.showDatesInputs = false
      }
    }
  },
  methods :{
    close() {
      this.$emit("input", !this.value);
    },
    remove(n, index) {
      if (n.id) {
        this.notice.files[index].enable = false;
      } else {
        this.notice.files.splice(index, 1);
      }
      this.$forceUpdate();
    },
     onSelectedFile(file) {
      if (!this.notice.files) {
        this.notice.files = [];
      }

      file.enable = true;
      this.notice.files.push(file);
      this.$forceUpdate();
    },
    deleteImage(imageStorage, index) {
      if (!this.notice.imageStorage) return;
      this.notice.imageStorage.splice(index, 1);
    },
    cambiaTipo(e){
      this.notice.type = e;
      this.v.type.$model = e;
    },
    confirmParentChange(event){
      this.notice.confirmParent = event
    },
    assistenceRequieredChange(event){
      this.notice.assistanceRequired = event
    },
    attendanceStudentRequiredChange(event){
      this.notice.attendanceStudentRequired = event
    },
  },
  data: () => ({
    editTitle: false,
    showTitleLabel: true,
    editDescription: false,
    showDescriptionText: true,
    showDatesText: true,
    showDatesInputs: false,
    styleObjectA: 'primary',
    styleObjectE: 'outline',
    
  }),
   computed: {
    // errores para los campos de titulo y descripción
    getDescription() {
      const description = '<span style="color: #686868; font-size: 1.5em; font-weith: bold">Descripción:</span> ' 
        + this.notice.description
      return description
    },
    titleErrors() {
				const errors = [];
				if (!this.v.title.$dirty) return errors;
				!this.v.title.required && errors.push("Título requerido");
				return errors;
		},
		descriptionErrors() {
				const errors = [];
				if (!this.v.description.$dirty) return errors;
				!this.v.description.required && errors.push("Descripción requerida");
				return errors;
		},
    // errores para los inputs de fecha
    dateStartErrors() {
      const errors = [];
      if (!this.v.startDate.$dirty) return errors;
      !this.v.startDate.required && errors.push("Fecha de inicio obligatoria");
      return errors;
    },
    dateEndErrors() {
      const errors = [];
      if (!this.v.endDate.$dirty) return errors;
      !this.v.endDate.validateDateEnd &&
        errors.push("La fecha final debe ser mayor a la de inicio");
      return errors;
    },
    dateStartEventErrors(){
      const errors = [];
      if(this.v.type.$model === "A"){ return [] }
      if (!this.v.startEventDate.$dirty) return errors;
      !this.v.startEventDate.validateDateStartEvent && errors.push("Fecha de inicio  del evento es incorrecta");


      !this.v.startEventDate.required && errors.push("La fecha de inicio de evento es obligatoria");
      return errors;
    },
    getMinStartDate() {
      return new Date().toLocaleDateString("sv-SE"); 
    },
    getMinEndDate(){
      if(this.v.startDate.$model){
        const date = new Date(this.v.startDate.$model).toLocaleDateString("sv-SE"); 
        return date
      }
      return ""
    },
    getMinStartEvent(){
      if(this.v.startDate.$model){
        const date = new Date(this.v.startDate.$model).toLocaleDateString("sv-SE"); 
        return date
      }
      return ""
    },
    getMaxStartEvent(){
      if(this.v.startDate.$model){
        const date = new Date(this.v.endDate.$model).toLocaleDateString("sv-SE"); 
        return date
      }
      return ""
    }
  },
  mounted()
  {

      if (this.notice.type == "A"){
        this.styleObjectA = 'primary' 
        this.styleObjectE = 'outline' 

      }else if(this.notice.type == "E")
      {
        this.styleObjectA = 'outline' 
        this.styleObjectE = 'primary' 
      }
  }
};
</script>

<style>
.innerContainer {
  border-radius: 13px;
  background-color: white;
  border-color: #e6e6e6 !important;
  border-top-style: solid;
  border-top-width: 1px;
  border-left-style: solid;
  border-left-width: 1px;
  border-right-style: solid;
  border-right-width: 1px;
  border-bottom-style: solid;
  border-bottom-width: 1px;
}

.no-pm{
  padding: 0% !important;
  margin: 0% !important;
} 

.black-label label  {
    color: red !important;
    font-weight: bold;
    font-size: 1.2em;
}
.black-label .theme--light.v-icon{
  color: red;
}

.black-label .theme--light.v-icon{
  color: red !important;
  caret-color:red !important;
}

.text-m-center {
  text-align: center !important;
  font-weight: bold;
  text-transform: uppercase;
}
</style>
